export const environment = {
  production: false,
  apiUrl: 'https://my-environment-api.telecom.hysdev.com',
  mainUrl: 'https://main.telecom.hysdev.com',
  pageSuffix: 'Staging',
  cms: {
    apiUrl: 'https://cms-telecom.telecom.hysdev.com',
    apiKey:
      '0e0b033be831e8534644450b138d6fb755591dbc7af1d844b8d6f51aeaf35d364f23fef452a8459dd68f8dcbaea0ad88b7f6d63bfa95353d4803675e25980c643b152f1fafc356dac9f4a52ed49d77e6d9c40bab5f00c5f7b0d697a25e6ca55be1153d2d062948b5425989fb86f8fbb41424c900b6fdf2e003cbcc38783870cd',
    autoLocale: true,
    previewMode: true,
    defaultLocale: 'en',
  },
  cm: {
    conversationId: '3ab02165-f85f-4e02-9c85-f714765b8174',
    scriptUrl: 'https://webchat.digitalcx.com/inline.js',
    targetId: 'chatbot',
  },
  lobbi: {
    scriptSrc: 'https://widget.test.lobbi.ai/latest/loader.js',
    widgetId: '01KG84MFFQQCSW6Y30B9M1Z6NS',
    server: 'https://test.lobbi.ai',
  },
  settings: {
    skipSmsVerification: false,
    skipEmailVerification: false,
  },
};
